'use client'

import React from 'react'

import { chakra } from '@chakra-ui/react'

import { fontFamilies } from '../../theme/fontFamilies'
import type { ColorScheme } from '../../types'
import { Pill, PillProps } from './Pill'

export type FacilityPillProps = Omit<PillProps, 'bg' | 'color'> & {
  colorScheme?: ColorScheme
}

export const FacilityPill = ({
  colorScheme = 'dark',
  children,
  ...rest
}: FacilityPillProps) => (
  <Pill
    bg={
      colorScheme === 'light' ? 'light.bg.chip-secondary' : 'bg.chip-secondary'
    }
    color={
      colorScheme === 'light'
        ? 'light.text.chip-secondary'
        : 'text.chip-secondary'
    }
    fontFamily={fontFamilies.soehneKraftig}
    fontSize='14px'
    fontWeight='500'
    maxWidth='100%'
    minWidth={0}
    overflow='hidden'
    {...rest}
  >
    <chakra.span
      display='block'
      overflow='hidden'
      textOverflow='ellipsis'
      whiteSpace='nowrap'
    >
      {children}
    </chakra.span>
  </Pill>
)
